import React from 'react';
import type {
  BaseProps,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';
import { labelSizeClasses } from 'src/modules/shared/styles/component.styles';
import { Text } from 'src/modules/shared/components/atoms/text';
import { stackedFieldLabelClassName } from 'src/modules/shared/styles/stacked-field.styles';

interface LabelProps extends BaseProps {
  onClick?: () => void;
  title?: string;
  required?: boolean;
  layout?: 'inline' | 'stacked';
  /** Id of the field this label names, so clicking it focuses the field. */
  htmlFor?: string;
}

const Label: React.FC<LabelProps> = ({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  onClick,
  title,
  required = false,
  layout = 'inline',
  htmlFor,
}) => {
  const baseClasses = ['transition-colors', 'duration-200', 'font-medium'];

  const variantTextColors: Record<ComponentVariant, string> = {
    primary: 'text-secondary-700',
    secondary: 'text-secondary-600',
    danger: 'text-danger-600',
    warning: 'text-warning-600',
    neutral: 'text-neutral-500',
    success: 'text-success-600',
    info: 'text-blue-600',
    whatsapp: 'text-whatsapp-600',
    call: 'text-call-600',
    email: 'text-email-600',
  };

  const classes = [
    ...baseClasses,
    variantTextColors[variant],
    layout === 'stacked' ? stackedFieldLabelClassName : labelSizeClasses[size],
    className,
  ].join(' ');

  return (
    <Text className={classes} as="label" htmlFor={htmlFor} onClick={onClick}>
      {title ?? children}
      {required && <span className="text-primary-500 ml-1">*</span>}
    </Text>
  );
};

export default Label;
